var _defs, _rect, _path, _line, _path2, _rect2, _path3, _path4, _path5, _path6, _rect3, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDivider(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#54575a;}.cls-3{fill:#3d85c6;}.cls-4{fill:none;stroke:#54575a;stroke-miterlimit:10;stroke-width:14px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.5,
    y: 25.5,
    width: 1149,
    height: 1149,
    rx: 95.94,
    ry: 95.94
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1078.56,35.5a86.26,86.26,0,0,1,85.94,85.94v957.11a86.26,86.26,0,0,1-85.94,85.94H121.44a86.26,86.26,0,0,1-85.94-85.94V121.44A86.26,86.26,0,0,1,121.44,35.5h957.11m0-20H121.44C63.17,15.5,15.5,63.17,15.5,121.44v957.11c0,58.27,47.67,105.94,105.94,105.94h957.11c58.27,0,105.94-47.68,105.94-105.94V121.44c0-58.27-47.68-105.94-105.94-105.94Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 151.38,
    y1: 599.75,
    x2: 1048.63,
    y2: 600.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.38,607.25h24l65.36,0,96.25.05,118.34.07,128.65.07,130.35.07,121.53.07,102.33.06,73.9,0c11.66,0,23.35.28,35,0,.5,0,1,0,1.5,0,9.65,0,9.67-15,0-15h-24l-65.36,0L863,592.65l-118.34-.07L616,592.51l-130.35-.07-121.53-.07-102.33-.06-73.9,0c-11.66,0-23.35-.28-35,0-.5,0-1,0-1.5,0-9.65,0-9.67,15,0,15Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 153,
    y: 157.17,
    width: 884.01,
    height: 269.66,
    rx: 22.38,
    ry: 22.38
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.44,213.92h18.39l50.38,0,74.18,0,91,.05,99.16.06,100.59.06,93.34.05,79.27,0,56.72,0c9,0,18,.27,26.94,0,.39,0,.79,0,1.19,0,7.72,0,7.73-12,0-12H922.17l-50.38,0-74.18,0-91-.05-99.16-.06-100.59-.06L413.56,202l-79.27,0-56.72,0c-9,0-18-.27-26.94,0-.39,0-.79,0-1.19,0-7.72,0-7.73,12,0,12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.44,269.84h18.39l50.38,0,74.18,0,91,.05,99.16.06,100.59.06,93.34.05,79.27,0,56.72,0c9,0,18,.27,26.94,0,.39,0,.79,0,1.19,0,7.72,0,7.73-12,0-12H922.17l-50.38,0-74.18,0-91-.05L607.49,258,506.9,258l-93.34-.05-79.27,0-56.72,0c-9,0-18-.27-26.94,0-.39,0-.79,0-1.19,0-7.72,0-7.73,12,0,12Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.44,325.76h18.39l50.38,0,74.18,0,91,.05,99.16.06L683.1,326l93.34.05,79.27,0,56.72,0c9,0,18,.27,26.94,0,.39,0,.79,0,1.19,0,7.72,0,7.73-12,0-12H922.17l-50.38,0-74.18,0-91-.05L607.49,314l-100.59-.06-93.34-.05-79.27,0-56.72,0c-9,0-18-.27-26.94,0-.39,0-.79,0-1.19,0-7.72,0-7.73,12,0,12Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.44,381.67h18.39l50.38,0,74.18,0,91,.05,99.16.06,100.59.06,93.34.05,79.27,0,56.72,0c9,0,18,.27,26.94,0,.39,0,.79,0,1.19,0,7.72,0,7.73-12,0-12H922.17l-50.38,0-74.18,0-91-.05-99.16-.06-100.59-.06-93.34-.05-79.27,0-56.72,0c-9,0-18-.27-26.94,0-.39,0-.79,0-1.19,0-7.72,0-7.73,12,0,12Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 163,
    y: 775.17,
    width: 884.01,
    height: 269.66,
    rx: 22.38,
    ry: 22.38
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.44,831.92h18.39l50.38,0,74.18,0,91,.05,99.16.06,100.59.06,93.34.05,79.27,0,56.72,0c9,0,18,.27,26.94,0,.39,0,.79,0,1.19,0,7.72,0,7.73-12,0-12H932.17l-50.38,0-74.18,0-91-.05-99.16-.06-100.59-.06L423.56,820l-79.27,0-56.72,0c-9,0-18-.27-26.94,0-.39,0-.79,0-1.19,0-7.72,0-7.73,12,0,12Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.44,887.84h18.39l50.38,0,74.18,0,91,.05,99.16.06,100.59.06,93.34.05,79.27,0,56.72,0c9,0,18,.27,26.94,0,.39,0,.79,0,1.19,0,7.72,0,7.73-12,0-12H932.17l-50.38,0-74.18,0-91-.05L617.49,876,516.9,876l-93.34-.05-79.27,0-56.72,0c-9,0-18-.27-26.94,0-.39,0-.79,0-1.19,0-7.72,0-7.73,12,0,12Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.44,943.76h18.39l50.38,0,74.18,0,91,.05,99.16.06L693.1,944l93.34.05,79.27,0,56.72,0c9,0,18,.27,26.94,0,.39,0,.79,0,1.19,0,7.72,0,7.73-12,0-12H932.17l-50.38,0-74.18,0-91-.05L617.49,932l-100.59-.06-93.34-.05-79.27,0-56.72,0c-9,0-18-.27-26.94,0-.39,0-.79,0-1.19,0-7.72,0-7.73,12,0,12Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.44,999.67h18.39l50.38,0,74.18,0,91,.05,99.16.06,100.59.06,93.34.05,79.27,0,56.72,0c9,0,18,.27,26.94,0,.39,0,.79,0,1.19,0,7.72,0,7.73-12,0-12H932.17l-50.38,0-74.18,0-91-.05-99.16-.06-100.59-.06-93.34-.05-79.27,0-56.72,0c-9,0-18-.27-26.94,0-.39,0-.79,0-1.19,0-7.72,0-7.73,12,0,12Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.d59a5c92c93a485ab07915b7f89542be.svg";
export { ForwardRef as ReactComponent };